import type { API, TRequestsHandler } from '~/utils/requestsProcessor/types';

export class StatisticsImpl {
  constructor(private readonly makeRequest: TRequestsHandler) {}

  /** GET /statistics/distribution */
  public getStatisticsDistribution(query: { from: string; until: string }) {
    return this.makeRequest<API.GetDistributableTokensStatsResponse[]>(`statistics/distribution`, {
      method: 'GET',
      query
    });
  }

  /** GET /statistics/transactions */
  public getStatisticsTransactions(query: { from: string; until: string }) {
    return this.makeRequest<API.GetTransactionStatisticsResponse>(`statistics/transactions`, {
      method: 'GET',
      query
    });
  }

  /** GET /v1/statistics/sold */
  public getV1StatisticsSold(query: { from: string; until: string; token: string }) {
    return this.makeRequest<API.GetSoldStatisticsResponseV1>(`v1/statistics/sold`, {
      method: 'GET',
      query
    });
  }

  /** GET /v1/statistics/rate */
  public getV1StatisticsRate(query: { from: string; until: string; token: string }) {
    return this.makeRequest<API.GetRateStatisticsResponseV1>(`v1/statistics/rate`, {
      method: 'GET',
      query
    }) as Promise<API.GetRateStatisticsResponseV1>;
  }

  /** GET /v1/statistics/dex */
  public getV1StatisticsDex(query: { from: string; until: string; token: string }) {
    return this.makeRequest<API.GetDexStatisticsResponseV1>(`v1/statistics/dex`, {
      method: 'GET',
      query
    }) as Promise<API.GetDexStatisticsResponseV1>;
  }

  /** GET /v1/statistics/holder */
  public getV1StatisticsHolder(query: { from: string; until: string; token: string }) {
    return this.makeRequest<API.GetHoldersStatisticsResponseV1>(`v1/statistics/holder`, {
      method: 'GET',
      query
    }) as Promise<API.GetHoldersStatisticsResponseV1>;
  }

  /** GET /v1/statistics/spent */
  public getV1StatisticsSpent(query: { from: string; until: string; token: string }) {
    return this.makeRequest<API.GetSpentStatisticsResponseV1>(`v1/statistics/spent`, {
      method: 'GET',
      query
    }) as Promise<API.GetSpentStatisticsResponseV1>;
  }

  /** GET /v1/statistics/buyback */
  public getV1StatisticsBuyback(query: { from: string; until: string; token: string }) {
    return this.makeRequest<API.GetBuybackStatisticsResponseV1>(`v1/statistics/buyback`, {
      method: 'GET',
      query
    }) as Promise<API.GetBuybackStatisticsResponseV1>;
  }

  /** GET /v1/statistics/pressure */
  public getV1StatisticsPressure(query: { from: string; until: string; token: string }) {
    return this.makeRequest<API.GetPressureStatisticsResponseV1>(`v1/statistics/pressure`, {
      method: 'GET',
      query
    }) as Promise<API.GetPressureStatisticsResponseV1>;
  }
}
